import * as yup from 'yup'

const schema = yup.object().shape({
  ticketDate: yup.date().required().typeError('Confirme uma data'),
})

export default schema
